import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=0f63e0de&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=0f63e0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63e0de",
  null
  
)

export default component.exports